import React, { useState, useRef, useEffect } from 'react';
import { User, Lock, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Avatar from './Avatar';

const UserMenu = ({ user, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Cerrar el menú cuando se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const menuItems = [
    { 
      icon: User, 
      label: 'Ver perfil', 
      action: () => {
        navigate('/app/profile');
        setIsOpen(false);
      }
    },
    { 
      icon: Lock, 
      label: 'Autenticación', 
      action: () => {
        navigate('/app/authentication');
        setIsOpen(false);
      }
    },
  ];

  return (
    <div className="relative" ref={menuRef}>
      {/* Avatar clickeable */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors"
      >
        <Avatar 
          name={user.name} 
          avatarUrl={user.avatarUrl}
          size="md"
        />
        <div className="text-left hidden sm:block">
          <p className="text-sm font-medium text-white">{user.name}</p>
          <p className="text-xs text-gray-400">{user.email}</p>
        </div>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-gray-900 border border-white/10 rounded-xl shadow-xl overflow-hidden z-50">
          {/* Menu Items */}
          <div className="py-2">
            {menuItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <button
                  key={index}
                  onClick={() => {
                    item.action();
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center space-x-3 px-4 py-3 hover:bg-white/5 transition-colors text-left"
                >
                  <Icon size={20} className="text-gray-400" />
                  <span className="text-white">{item.label}</span>
                </button>
              );
            })}
          </div>

          {/* Separator */}
          <div className="border-t border-white/10"></div>

          {/* Sign Out */}
          <div className="py-2">
            <button
              onClick={() => {
                onLogout();
                setIsOpen(false);
              }}
              className="w-full flex items-center space-x-3 px-4 py-3 hover:bg-white/5 transition-colors text-left"
            >
              <LogOut size={20} className="text-gray-400" />
              <span className="text-white">Cerrar sesión</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
